import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className="d-flex align-items-center min-vh-100 bg-auth border-top border-top-2 border-primary">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={5} xl={4} className="my-5">
            <div className="text-center">
              <h1 className="display-4 mb-3">Unauthorized</h1>
              <p className="text-muted mb-4">You currently do not have access to this page.</p>
              <Link to="/">
                <Button size="lg">Return to your dashboard</Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Unauthorized;
